var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer",domProps:{"innerHTML":_vm._s(_vm.logo)},on:{"click":function($event){return _vm.$router.push('/dashboard')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }